import { ApiRequestError } from '@/lib/api';

/** Motivo que da el API (p. ej. evaluación con intentos) o un mensaje accionable. */
export function deleteQuizErrorMessage(err: unknown): string {
  if (err instanceof ApiRequestError) {
    // Solo 400 y 409 traen un motivo pensado para el usuario.
    if (err.status === 400 || err.status === 409) return err.message;
    if (err.status === 403) return 'No tiene permiso para eliminar esta evaluación.';
    if (err.status === 404) return 'Esta evaluación ya no existe. Cierre y actualice la página.';
  }
  return 'No se pudo eliminar la evaluación. Intente de nuevo.';
}
